// JsFromRoutes CacheKey ce8cbe45c29b2132879322523c3362d1
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/categories"),
  create: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/categories"),
  show: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/categories/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/:venue_slug/categories/:id"),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/api/:venue_slug/categories/:id"),
}
